import React from 'react';
import { COLORS } from '../../constants';

const ArchivedLabel: React.FC = () => {
  return (
    <span
      className="text-sm whitespace-nowrap"
      style={{ color: COLORS.ARCHIVED_TEXT }}
    >
      (Archived)
    </span>
  );
};

export default ArchivedLabel;
